import { USER_KEY } from "config/constants";
import { showError } from "services/toast.service";

const { AUTH_TOKEN } = require("config/constants");

export const isLogin = () => {
  return !!localStorage.getItem(AUTH_TOKEN);
};

export const handleError = (error) => {
  const response = error.response;
  console.log('response is ', error);
  if(response) {
    const { data } = response;
    if (data.result) {
      showError(data.result.message);
    } else if (data.errors) {
      showError(data.errors[0].msg);
    }
  } else {
    showError("Something went wrong!");
  }

};

export const getAccessToken = () => {
  return localStorage.getItem(AUTH_TOKEN);
}


export const getUser = () => {
  return JSON.parse(localStorage.getItem(USER_KEY));
}

export const getCoverage = (matchedRequest, adRequest) => {
  return ((matchedRequest * 100) / adRequest).toFixed(2) + "%";
}